// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__277eM","name":"Header_name__15tS_","birthday":"Header_birthday__gDDU0","skeleton":"Header_skeleton__UR0f8"};